module.exports = __webpack_public_path__ + "img/andrew-collect-emails.92ac1cef.png";